import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { getPortfolioAllocationAccountGroupsMap } from 'state/account/SelectAccountsFilteringSelectors';
import { PortfolioAllocation } from '@trp-ii-ii-component-library/ii-components';
import { getApiKey } from 'state/config/ConfigSelectors';
import { getActiveAccounts } from 'state/account/AccountSelectors';

const groupsSortOrder = [
  'activeAdvisory',
  'activePlus',
  'mutualFund',
  'brokerage',
  'retirement',
  'nonRetirement',
  'owned',
  'related',
  'viewOnly'
];

const PortfolioAllocationCardWrapper = ({ accounts, groups, apiKey }) => {
  const [sortedGroups, setSortedGroups] = useState([]);

  useEffect(() => {
    const sortedGroups = [];
    groupsSortOrder.forEach((groupValue) => {
      if (groups[groupValue]) {
        sortedGroups.push({
          groupName: groups[groupValue].label,
          groupId: groups[groupValue].value,
          accountIds: groups[groupValue].accountIds
        });
      }
    });

    Object.entries(groups)
      .filter(([key]) => !sortedGroups.some(({groupId}) => groupId == key))
      .forEach(([, customGroup]) => {
        sortedGroups.push({
          groupName: customGroup.label,
          groupId: customGroup.value,
          accountIds: customGroup.accountIds
        });
      });

    sortedGroups.push({
      groupName: 'All',
      groupId: 'all',
      accountIds: accounts.map(({accountId}) => accountId)
    });
    setSortedGroups(sortedGroups);
  }, [groups])


  return sortedGroups.length > 0 ? (
    <PortfolioAllocation
      customGroups={sortedGroups}
      apiKey={apiKey}
    ></PortfolioAllocation>
  ) : null;
}

const mapStateToProps = (state) => ({
  accounts: getActiveAccounts(state),
  groups: getPortfolioAllocationAccountGroupsMap(state),
  apiKey: getApiKey(state)
});

export default connect(mapStateToProps)(PortfolioAllocationCardWrapper);
